import { render } from "./ThemePicker.vue?vue&type=template&id=c2c67cc0&scoped=true"
import script from "./ThemePicker.vue?vue&type=script&lang=js"
export * from "./ThemePicker.vue?vue&type=script&lang=js"

import "./ThemePicker.vue?vue&type=style&index=0&id=c2c67cc0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2c67cc0"]])

export default __exports__